module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/base-module/components/button/button.component.scss
// module id = ./src/app/modules/base-module/components/button/button.component.scss
// module chunks = 9